export default __webpack_public_path__ + "static/media/2nd (1).f9c4c1a3.png";